import {
    updateStateAfterWidgetOptionChange,
    isMdaeWidgetOptionChangeEvent,
} from "../../../common_components/mdae-framework";
import { cloneDeep, cloneDeepWith } from 'lodash';
export const TOGGLE_ROUND_TASK_POPUP = 'TOGGLE_ROUND_TASK_POPUP';
export const ADD_EA_ROUND_TASK = 'ADD_EA_ROUND_TASK';
export const SET_EA_ROUND_DATA = "SET_EA_ROUND_DATA";
const initialError = {
    code: '',
    message: '',
    value: []
};

const initialState = {
    loading: false,
    error: initialError,
    eaRound:[{eaRoundTaskList:[],sequenceNo:1}]
};
export default (state = initialState, action) => {
    let newState;
    switch (action.type) {
        case SET_EA_ROUND_DATA:
        case TOGGLE_ROUND_TASK_POPUP:
            newState = cloneDeep(state);
            if (isMdaeWidgetOptionChangeEvent(action.data)) {
                newState = updateStateAfterWidgetOptionChange(newState, action.data);
            } else {
                newState = { ...newState, ...action.data };
            }
            return newState;
        case ADD_EA_ROUND_TASK:
            newState = cloneDeepWith(state);
            if (isMdaeWidgetOptionChangeEvent(action.data)) {
                newState = updateStateAfterWidgetOptionChange(newState, action.data);
            } else {
                if(action.data.taskData){
                for(var item of newState.eaRound){
                    item.eaRoundTaskList?.push(action.data.taskData); 
                }
            }}
            return newState;
        default:
            return state;
    }
};

export const formatEaRoundTaskObjectToSave =(data,roundItem,templateSelected)=>{
    var refTaskItem = templateSelected[0];
    var SequenceNo = 1;
    for(var item of roundItem[0].eaRoundTaskList){
      SequenceNo = item.sequenceNo + 1;
    }
    var requiredTaskData = [
      {
    level:data.level == 'EA'?'Audit':'Case',
    eaProcessTemplateRoundId:roundItem[0].sequenceNo,
    refTaskId:data.refTaskId,
    sequenceNo:SequenceNo,
    dependentTaskTriggerId:data?.previousTaskStatusId,
    triggerValue:data.status,
    triggerType:data.triggerType,
    requiredForAuditCompletionInd:refTaskItem.requiredForAuditCompletionInd,
    templateDescription:refTaskItem.description,
    dueInDays:refTaskItem.dueAfter?(refTaskItem.dueAfter +' '+ refTaskItem.dueInterval):'',
    taskCategoryName:refTaskItem.taskCategoryName,
    taskCategoryType:data.categoryType[0].displayName,
    refTaskName:refTaskItem.displayName?refTaskItem.displayName:refTaskItem.name,
      }
    ];
  return requiredTaskData[0];
  }   